export const ACTIVITY_MESSAGE = 'activity';
export const ERROR_MESSAGE = 'error';
export const INFO_MESSAGE = 'info';
export const STATUS_MESSAGE = 'status';

export const isActivity = type => type === ACTIVITY_MESSAGE;
export const isError = type => type === ERROR_MESSAGE;
export const isInfo = type => type === INFO_MESSAGE;
export const isStatus = type => type === STATUS_MESSAGE;
